<template>
  <link rel="stylesheet" href="/assets/css/contact.css">
  <main id="main" class="main">
    <section class="section fade-in-contacts-view">
      <div class="row">
        <div class="col-lg-12">
          <div class="card shadow">
            <div class="card-body p-4">
              <div class="row">
                <div class="col-sm-9">
                  <div class="pagetitle">
                    <h1 class="text-left">CONTACT LIST</h1>
                    <nav>
                      <ol class="breadcrumb breadJa">
                        <router-link :to="{ name: 'home' }" class="breadcrumb-item">Home</router-link>
                        <router-link :to="{ name: 'contact' }" class="breadcrumb-item">Contact</router-link>
                      </ol>
                    </nav>
                  </div>
                </div>
                <div class="col-3">
                </div>
              </div>

              <div class="row mb-3">
                <div class="col-md-3">
                  <label for="instanceSelect" class="form-label fw-bold">
                    <i class="bi bi-phone-fill me-2"></i>
                    Select Instance
                  </label>
                  <select 
                    class="form-select"
                    id="instanceSelect"
                    v-model="selectedInstance"
                    @change="onInstanceChange"
                  >
                    <option :value="null">-- Choose an instance --</option>
                    <option 
                      v-for="instance in onlineInstances" 
                      :key="instance.instanceId"
                      :value="instance"
                    >
                      {{ instance.phoneNumber || 'No Number' }} ({{ instance.instanceId.substring(0, 6) }})
                    </option>
                  </select>
                  <div v-if="onlineInstances.length === 0" class="alert alert-warning mt-2 mb-0" role="alert">
                    <i class="bi bi-exclamation-triangle me-2"></i>
                    <small>No online instances available.</small>
                  </div>
                </div>
              </div>

              <!-- Selected Instance Info -->
              <div v-if="selectedInstance" class="alert alert-info mb-3">
                <i class="bi bi-info-circle me-2"></i>
                <strong>Active Instance:</strong> {{ selectedInstance.phoneNumber }} 
                <span class="badge bg-success ms-2">Online</span>
              </div>

              <div class="row mb-3" v-if="selectedInstance">
                <div class="col-md-6">
                  <div class="d-flex align-items-center gap-2">
                    <label class="me-2 mb-0">Show</label>
                    <select v-model="limit" @change="handleLimitChange" class="form-select form-select-sm" style="width: auto;">
                      <option :value="10">10</option>
                      <option :value="25">25</option>
                      <option :value="50">50</option>
                      <option :value="100">100</option>
                    </select>
                    <label class="ms-2 mb-0">entries</label>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="d-flex justify-content-end gap-2">
                    <div class="btn-group" role="group">
                      <button
                        type="button"
                        class="btn btn-chatroom btn-primary-chatroom"
                        @click="exportContacts('xlsx')"
                        :disabled="loading || !selectedInstance"
                        title="Export to Excel"
                      >
                        <i class="bi bi-file-earmark-excel me-1"></i>
                        Excel
                      </button>
                      <button
                        type="button"
                        class="btn btn-chatroom btn-outline-primary-contacts"
                        @click="exportContacts('csv')"
                        :disabled="loading || !selectedInstance"
                        title="Export to CSV"
                      >
                        <i class="bi bi-filetype-csv me-1"></i>
                        CSV
                      </button>
                    </div>

                    <div class="input-group input-group-sm input-group-contacts" style="width: 250px;">
                      <span class="input-group-text">
                        <i class="bi bi-search"></i>
                      </span>
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        placeholder="Search contacts..."
                        v-model="searchQuery"
                        @input="handleSearch"
                      >
                    </div>
                  </div>
                </div>
              </div>

              <!-- Empty State - No Instance Selected -->
              <div v-if="!selectedInstance" class="text-center py-5">
                <div class="alert alert-warning d-inline-block mb-4" role="alert">
                  <i class="bi bi-exclamation-triangle-fill me-2"></i>
                  <strong>Harap pilih nomor instance terlebih dahulu</strong>
                </div>
                <div class="illustration-container">
                  <Vue3Lottie  
                    animationLink="/assets/Contact.json"
                    :height="280" 
                    :width="280"
                    :loop="true"
                    :autoPlay="true"
                  />
                </div>
                <p class="text-muted mt-3 mb-0">Please select an instance above to view contacts</p>
              </div>

              <!-- Table - Only show when instance is selected -->
              <div v-else class="table-responsive">
                <table class="table table-hover shadow-sm table-bordered">

                  <thead class="table-primary">
                    <tr style="vertical-align:middle; text-align: center;">
                      <th scope="col" width="5%">No</th>
                      <th scope="col">JID</th>
                      <th scope="col">Name</th>
                      <th scope="col" width="10%">Type</th>
                      <th scope="col" width="10%">Action</th>
                    </tr>
                  </thead>

                  <tbody class="table-group-divider">
                    <!-- Loading State -->
                    <tr v-if="loading">
                      <td colspan="5">
                        <div class="d-flex justify-content-center text-primary m-3">
                          <strong role="status" class="pt-1" style="padding-right: 2rem;">Loading...</strong>
                          <div class="spinner-border shadow" aria-hidden="true"></div>
                        </div>
                      </td>
                    </tr>

                    <!-- Contact Rows -->
                    <tr
                      v-else-if="filteredContacts.length > 0"
                      v-for="(contact, index) in filteredContacts"
                      :key="contact.jid"
                      style="vertical-align:middle;"
                      class="fade-in-pengaduan-view"
                    >
                      <th scope="row" style="text-align: center;" nowrap>
                        {{ (page - 1) * limit + index + 1 }}
                      </th>
                      <td style="text-align: left;">
                        <code class="text-muted small">{{ contact.jid }}</code>
                      </td>
                      <td style="text-align: left;">
                        <strong>{{ contact.name || '-' }}</strong>
                      </td>
                      <td nowrap style="text-align: center;">
                        <span 
                          class="badge rounded-pill"
                          :class="contact.isGroup ? 'bg-info' : 'bg-success'"
                        >
                          <i :class="contact.isGroup ? 'bi bi-people-fill' : 'bi bi-person-fill'" class="me-1"></i>
                          {{ contact.isGroup ? 'Group' : 'Personal' }}
                        </span>
                      </td>
                      <td nowrap style="text-align: center;">
                        <button
                          class="btn btn-chatroom btn-primary-chatroom"
                          @click="viewContactDetail(contact)"
                          title="View Detail"
                        >
                          <i class="bi bi-eye"></i>
                        </button>
                      </td>
                    </tr>

                    <!-- No Results -->
                    <tr v-else-if="!loading && filteredContacts.length === 0">
                      <td colspan="5" class="text-center py-4">
                        <i class="bi bi-inbox text-muted" style="font-size: 2rem;"></i>
                        <p class="text-muted mt-2 mb-0">
                          {{ searchQuery ? 'No contacts found matching your search.' : 'No contacts found.' }}
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- Pagination Info & Controls -->
              <div v-if="selectedInstance && !loading && filteredContacts.length > 0" class="row align-items-center">
                <div class="col-md-6">
                  <p class="text-muted mb-0">
                    Showing {{ (page - 1) * limit + 1 }} to {{ Math.min(page * limit, total) }} of {{ total }} entries
                    <span v-if="searchQuery" class="text-primary">(filtered from {{ totalContacts }} total entries)</span>
                  </p>
                </div>
                <div class="col-md-6">
                  <nav aria-label="Page navigation">
                    <ul class="pagination justify-content-end mb-0">
                      <!-- Previous Button -->
                      <li class="page-item" :class="{ disabled: !hasPrevPage }">
                        <button 
                          class="page-link" 
                          @click.prevent="goToPage(page - 1)"
                          :disabled="!hasPrevPage"
                        >
                          <i class="bi bi-chevron-left"></i>
                          Previous
                        </button>
                      </li>

                      <!-- Page Numbers -->
                      <li 
                        v-for="pageNum in visiblePages" 
                        :key="pageNum"
                        class="page-item"
                        :class="{ active: pageNum === page }"
                      >
                        <button 
                          class="page-link" 
                          @click.prevent="goToPage(pageNum)"
                        >
                          {{ pageNum }}
                        </button>
                      </li>

                      <!-- Next Button -->
                      <li class="page-item" :class="{ disabled: !hasNextPage }">
                        <button 
                          class="page-link" 
                          @click.prevent="goToPage(page + 1)"
                          :disabled="!hasNextPage"
                        >
                          Next
                          <i class="bi bi-chevron-right"></i>
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Contact Detail Modal -->
    <div class="modal fade" id="contactDetailModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              <i class="bi bi-person-circle me-2"></i>
              Contact Detail
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <!-- Loading State -->
            <div v-if="loadingDetail" class="text-center py-4">
              <div class="illustration-container">
                <Vue3Lottie  
                  animationLink="/assets/detail-profile.json"
                  :height="200" 
                  :width="200"
                  :loop="true"
                  :autoPlay="true"
                />
              </div>
              <p class="text-muted mt-2 mb-0">Loading contact details...</p>
            </div>

            <!-- Contact Detail -->
            <div v-else-if="contactDetail" class="contact-detail">
              <div class="row">
                <!-- Left Column: Contact Information -->
                <div class="col-md-7">
                  <!-- Profile Picture -->
                  <div class="text-center mb-4">
                    <img 
                      v-if="contactDetail.profilePicture" 
                      :src="contactDetail.profilePicture" 
                      alt="Profile Picture"
                      class="rounded-circle"
                      style="width: 120px; height: 120px; object-fit: cover;"
                      @error="handleImageError"
                    >
                    <div v-else class="rounded-circle bg-secondary d-inline-flex align-items-center justify-content-center" style="width: 120px; height: 120px;">
                      <i class="bi bi-person-fill text-white" style="font-size: 3rem;"></i>
                    </div>
                  </div>

                  <!-- Contact Information -->
                  <div class="contact-info">
                    <div class="info-item mb-3">
                      <label class="text-muted small mb-1"><i class="bi bi-person me-1"></i> Name</label>
                      <div class="fw-bold">{{ contactDetail.name || '-' }}</div>
                    </div>

                    <div class="info-item mb-3" v-if="contactDetail.pushName">
                      <label class="text-muted small mb-1"><i class="bi bi-chat-left-text me-1"></i> Push Name</label>
                      <div class="fw-bold">{{ contactDetail.pushName }}</div>
                    </div>

                    <div class="info-item mb-3">
                      <label class="text-muted small mb-1"><i class="bi bi-telephone me-1"></i> Phone Number</label>
                      <div class="fw-bold">{{ contactDetail.phoneNumber || '-' }}</div>
                    </div>

                    <div class="info-item mb-3">
                      <label class="text-muted small mb-1"><i class="bi bi-hash me-1"></i> JID</label>
                      <div><code class="small">{{ contactDetail.jid }}</code></div>
                    </div>

                    <div class="info-item mb-3" v-if="contactDetail.about">
                      <label class="text-muted small mb-1"><i class="bi bi-info-circle me-1"></i> About</label>
                      <div>{{ contactDetail.about }}</div>
                    </div>

                    <div class="info-item mb-3" v-if="contactDetail.businessName">
                      <label class="text-muted small mb-1"><i class="bi bi-briefcase me-1"></i> Business Name</label>
                      <div class="fw-bold">{{ contactDetail.businessName }}</div>
                    </div>

                    <div class="info-item mb-3">
                      <label class="text-muted small mb-1"><i class="bi bi-shield-check me-1"></i> Account Type</label>
                      <div>
                        <span class="badge" :class="contactDetail.isBusiness ? 'bg-warning' : 'bg-info'">
                          {{ contactDetail.isBusiness ? 'Business' : 'Personal' }}
                        </span>
                        <span v-if="contactDetail.isGroup" class="badge bg-primary ms-1">Group</span>
                        <span v-if="contactDetail.verifiedName" class="badge bg-success ms-1">
                          <i class="bi bi-patch-check-fill"></i> Verified
                        </span>
                      </div>
                    </div>

                    <div class="info-item mb-3" v-if="contactDetail.verifiedName">
                      <label class="text-muted small mb-1"><i class="bi bi-patch-check me-1"></i> Verified Name</label>
                      <div class="fw-bold">{{ contactDetail.verifiedName }}</div>
                    </div>
                  </div>
                </div>

                <!-- Right Column: Mutual Groups -->
                <div class="col-md-5" v-if="!contactDetail.isGroup">
                  <div class="mutual-groups-section h-100">
                    <div class="border-start ps-3 h-100">
                      <h6 class="mb-3">
                        <i class="bi bi-people me-2"></i> Mutual Groups
                        <span v-if="mutualGroups.length > 0" class="badge bg-primary ms-1">{{ mutualGroups.length }}</span>
                      </h6>
                      
                      <div v-if="!mutualGroupsLoaded && !loadingMutualGroups" class="text-center py-4">
                        <button
                          class="btn btn-chatroom btn-primary-chatroom"
                          @click="fetchMutualGroups(contactDetail.jid)"
                        >
                          <i class="bi bi-search me-2"></i>
                          Show Mutual Groups
                        </button>
                      </div>

                      <!-- Loading Mutual Groups -->
                      <div v-else-if="loadingMutualGroups" class="text-center py-4">
                        <div class="spinner-border text-primary" role="status">
                          <span class="visually-hidden">Loading...</span>
                        </div>
                        <p class="text-muted small mt-3 mb-0">Loading mutual groups...</p>
                      </div>

                      <!-- Mutual Groups List -->
                      <div v-else-if="mutualGroups.length > 0" class="mutual-groups-list" style="max-height: 400px; overflow-y: auto;">
                        <div class="list-group list-group-flush">
                          <div 
                            v-for="(group, index) in mutualGroups" 
                            :key="index"
                            class="list-group-item px-0 py-2 border-0"
                          >
                            <i class="bi bi-people-fill text-primary me-2"></i>
                            <span class="small">{{ group }}</span>
                          </div>
                        </div>
                      </div>

                      <!-- No Mutual Groups -->
                      <div v-else-if="mutualGroupsLoaded && mutualGroups.length === 0" class="text-center py-4">
                        <i class="bi bi-info-circle text-muted" style="font-size: 2rem;"></i>
                        <p class="text-muted small mt-2 mb-0">No mutual groups</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Error State -->
            <div v-else class="text-center py-4">
              <i class="bi bi-exclamation-triangle text-warning" style="font-size: 3rem;"></i>
              <p class="text-muted mt-2 mb-0">Failed to load contact details</p>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import axios from 'axios';
import { Vue3Lottie } from 'vue3-lottie';

export default {
  components: {
    Vue3Lottie
  },
  data() {
    return {
      instances: [],
      selectedInstance: null,
      contacts: [],
      page: 1,
      limit: 10,
      total: 0,
      totalPages: 0,
      hasNextPage: false,
      hasPrevPage: false,
      baseUrl: process.env.VUE_APP_BE_APP_BASE_URL,
      loading: false,
      searchQuery: '',
      searchTimeout: null,
      totalContacts: 0,
      savedScrollPosition: 0,
      contactDetail: null,
      loadingDetail: false,
      mutualGroups: [],
      loadingMutualGroups: false,
      mutualGroupsLoaded: false,
      mutualGroupsFetchKey: '',  // Track which contact is being fetched
    };
  },

  computed: {
    onlineInstances() {
      return Array.isArray(this.instances) 
        ? this.instances.filter(inst => inst.status === 'online') 
        : [];
    },

    filteredContacts() {
      // Return contacts as-is since we're doing server-side search
      return this.contacts;
    },

    visiblePages() {
      const pages = [];
      const maxVisible = 5;
      let startPage = Math.max(1, this.page - Math.floor(maxVisible / 2));
      let endPage = Math.min(this.totalPages, startPage + maxVisible - 1);

      // Adjust start if we're near the end
      if (endPage - startPage < maxVisible - 1) {
        startPage = Math.max(1, endPage - maxVisible + 1);
      }

      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }

      return pages;
    }
  },

  mounted() {
    this.fetchInstances();
  },

  methods: {
    async fetchInstances() {
      try {
        const response = await axios.get(`${this.baseUrl}/api/instances?all=true`);
        const data = response.data.data.instances || response.data.data || [];
        this.instances = Array.isArray(data) ? data : [];
      } catch (error) {
        console.error('Failed to fetch instances:', error);
        this.instances = [];
        this.Toasttt('Failed to load instances', 'error');
      }
    },

    async fetchContacts() {
      if (!this.selectedInstance) {
        this.contacts = [];
        return;
      }

      this.loading = true;

      try {
        const response = await axios.get(
          `${this.baseUrl}/api/contacts/${this.selectedInstance.instanceId}`,
          {
            params: {
              page: this.page,
              limit: this.limit,
              search: this.searchQuery || undefined  // Send search query to backend
            }
          }
        );

        const data = response.data.data;
        this.contacts = data.contacts || [];
        this.total = data.total || 0;
        this.totalContacts = data.total || 0;
        this.totalPages = data.totalPages || 1;
        this.hasNextPage = data.hasNextPage || false;
        this.hasPrevPage = data.hasPrevPage || false;

        // Restore scroll position if saved
        if (this.savedScrollPosition > 0) {
          this.$nextTick(() => {
            window.scrollTo(0, this.savedScrollPosition);
            this.savedScrollPosition = 0;
          });
        }

      } catch (error) {
        console.error('Failed to fetch contacts:', error);
        this.contacts = [];
        this.total = 0;
        this.Toasttt(
          'Failed to load contacts',
          'error',
          error?.response?.data?.message || ''
        );
      } finally {
        this.loading = false;
      }
    },

    onInstanceChange() {
      // Reset pagination and search when instance changes
      this.page = 1;
      this.contacts = [];
      this.total = 0;
      this.searchQuery = '';
      this.fetchContacts();
    },

    handleLimitChange() {
      // Reset to page 1 when limit changes
      this.page = 1;
      this.fetchContacts();
    },

    handleSearch() {
      // Debounce search to avoid too many API requests
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      
      this.searchTimeout = setTimeout(() => {
        // Reset to page 1 when searching
        this.page = 1;
        this.fetchContacts();
      }, 500); // Wait 500ms after user stops typing
    },

    goToPage(pageNum) {
      if (pageNum < 1 || pageNum > this.totalPages) return;
      
      // Save current scroll position before changing page
      this.savedScrollPosition = window.scrollY || window.pageYOffset;
      
      this.page = pageNum;
      this.fetchContacts();
    },

    async viewContactDetail(contact) {
      if (!this.selectedInstance || !contact.jid) return;

      this.contactDetail = null;
      this.loadingDetail = true;
      this.mutualGroups = [];
      this.mutualGroupsLoaded = false;
      
      // Check if this contact has an ongoing fetch in sessionStorage
      const fetchKey = `${this.selectedInstance.instanceId}_${contact.jid}`;
      const ongoingFetch = sessionStorage.getItem('mutualGroupsFetching');
      
      if (ongoingFetch === fetchKey) {
        // This contact is still being fetched, keep loading state
        this.loadingMutualGroups = true;
        this.mutualGroupsFetchKey = fetchKey;
      } else {
        // Different contact or no ongoing fetch
        this.loadingMutualGroups = false;
        this.mutualGroupsFetchKey = '';
      }

      // Show modal
      const modal = new bootstrap.Modal(document.getElementById('contactDetailModal'));
      modal.show();

      try {
        // Fetch data and ensure minimum delay for animation
        const [response] = await Promise.all([
          axios.get(
            `${this.baseUrl}/api/contacts/${this.selectedInstance.instanceId}/${contact.jid}`
          ),
          new Promise(resolve => setTimeout(resolve, 1000)) // Minimum 1 second delay
        ]);

        if (response.data.success) {
          this.contactDetail = response.data.data;
        } else {
          this.Toasttt('Failed to load contact details', 'error', response.data.message);
        }
      } catch (error) {
        console.error('Failed to fetch contact detail:', error);
        this.Toasttt(
          'Failed to load contact details',
          'error',
          error?.response?.data?.message || ''
        );
      } finally {
        this.loadingDetail = false;
      }
    },

    async fetchMutualGroups(jid) {
      if (!this.selectedInstance || !jid) return;

      const fetchKey = `${this.selectedInstance.instanceId}_${jid}`;
      
      this.loadingMutualGroups = true;
      this.mutualGroups = [];
      this.mutualGroupsFetchKey = fetchKey;
      
      // Store in sessionStorage that this contact is being fetched
      sessionStorage.setItem('mutualGroupsFetching', fetchKey);

      try {
        const response = await axios.get(
          `${this.baseUrl}/api/contacts/${this.selectedInstance.instanceId}/${jid}/mutual-groups`
        );

        if (response.data.success) {
          this.mutualGroups = response.data.data.mutualGroups || [];
          this.mutualGroupsLoaded = true;
        }
      } catch (error) {
        // Handle 409 - Another request is already in progress
        if (error.response && error.response.status === 409) {
          const errorData = error.response.data;
          const detailMessage = errorData.error?.details || errorData.message || 'Mutual groups check already in progress, please wait...';
          
          this.Toasttt(
            'Please wait',
            'warning',
            detailMessage
          );
          return;
        }
        
        console.error('Failed to fetch mutual groups:', error);
        this.mutualGroups = [];
      } finally {
        this.loadingMutualGroups = false;
        
        // Clear sessionStorage when done
        const currentFetchKey = `${this.selectedInstance.instanceId}_${jid}`;
        if (sessionStorage.getItem('mutualGroupsFetching') === currentFetchKey) {
          sessionStorage.removeItem('mutualGroupsFetching');
        }
        this.mutualGroupsFetchKey = '';
      }
    },

    async exportContacts(format = 'xlsx') {
      if (!this.selectedInstance) {
        this.Toasttt('Error', 'error', 'Please select an instance first');
        return;
      }

      // Confirmation dialog
      const result = await this.$swal.fire({
        title: 'Export Contacts',
        html: `Are you sure you want to export contacts to <strong>${format.toUpperCase()}</strong>?<br><br>` +
              `<small class="text-muted">Instance: ${this.selectedInstance.instanceId}</small>` +
              (this.searchQuery ? `<br><small class="text-muted">Filter: "${this.searchQuery}"</small>` : ''),
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#198754',
        cancelButtonColor: '#6c757d',
        confirmButtonText: `<i class="bi bi-download me-1"></i> Export ${format.toUpperCase()}`,
        cancelButtonText: 'Cancel'
      });

      if (!result.isConfirmed) {
        return;
      }

      try {
        const response = await axios.get(
          `${this.baseUrl}/api/contacts/${this.selectedInstance.instanceId}/export`,
          {
            params: {
              format: format,
              search: this.searchQuery || undefined
            },
            responseType: 'blob'
          }
        );

        // Create download link
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        
        // Set filename from response header or use default
        const contentDisposition = response.headers['content-disposition'];
        let filename = `contacts_${this.selectedInstance.instanceId}.${format}`;
        
        if (contentDisposition) {
          const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
          if (filenameMatch && filenameMatch[1]) {
            filename = filenameMatch[1];
          }
        }
        
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        this.Toasttt('Success', 'success', `Contacts exported to ${format.toUpperCase()}`);
      } catch (error) {
        console.error('Failed to export contacts:', error);
        this.Toasttt(
          'Export Failed',
          'error',
          error?.response?.data?.message || 'Failed to export contacts'
        );
      }
    },


    Toasttt(msg, type, detail){
        const Toast = this.$swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            background: "#F8F8F8",
            didOpen: (toast) => {
                toast.onmouseenter = this.$swal.stopTimer;
                toast.onmouseleave = this.$swal.resumeTimer;
            }
        });
            Toast.fire({
            icon: type,
            title: msg,
            text: detail,
        });
      },

    handleImageError(event) {
      // Hide broken image
      event.target.style.display = 'none';
    }
  }
};
</script>
